import React from 'react'
import { Icon } from '@iconify/react'
import Image from '../assets/images/gainservo-logo.png'

const Footer = () => {
  return (
    <footer className="bg-gray-50 text-[#CCDC59]">
      <div className="max-w-[1440px] mx-auto px-4 py-8">
        <div className="grid md:grid-cols-4 lg:gap-20 gap-8">
          {/* Şirket Bilgileri */}
          <div>
            <div className="mb-4">
              <img className=" w-auto" src={Image} alt="Gainservo" />
            </div>
            <p className="text-[#2E3192] text-sm">
            20 yılı aşkın kurumsal deneyimimizi, Şubat 2025 itibarıyla doğrudan sizinle buluşturduk. Artık bilgiye, kaliteye ve güvene bir aracı olmadan ulaşmanın zamanı geldi. Geçmişin birikimiyle, geleceğin hizmet anlayışını birleştiriyoruz.
            </p>
          </div>
          
          {/* Hızlı Linkler */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#2E3192]">Hızlı Linkler</h3>
            <ul className="space-y-2 text-sm">
              <li><a href="/" className="text-[#2E3192] hover:text-[#CCDC59] transition duration-300">Ana Sayfa</a></li>
              <li><a href="/hizmetler" className="text-[#2E3192] hover:text-[#CCDC59] transition duration-300">Hizmetlerimiz</a></li>
              <li><a href="/hakkimizda" className="text-[#2E3192] hover:text-[#CCDC59] transition duration-300">Hakkımızda</a></li>
              <li><a href="/contact-us" className="text-[#2E3192] hover:text-[#CCDC59] transition duration-300">İletişim</a></li>
            </ul>
          </div>
          
          {/* İletişim Bilgileri */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#2E3192]">İletişim</h3>
            <div className="space-y-2 text-sm text-[#2E3192]">
              <p className="flex items-center gap-2">
                <Icon icon="logos:whatsapp-icon" className="w-4 h-4" /><Icon icon="logos:telegram" className="w-4 h-4" />
                +90 541 396 7820
              </p>
              <p className="flex items-center gap-2">
              <Icon icon="logos:whatsapp-icon" className="w-4 h-4" /><Icon icon="logos:telegram" className="w-4 h-4" />
                +90 501 032 5260
              </p>
              <p className="flex items-center gap-2">
                <Icon icon="mdi:email" className="w-4 h-4" />
                info@gainservo.com
              </p>
              {/* <p className="flex items-center gap-2">
                <Icon icon="mdi:email" className="w-4 h-4" />
                info@gainservo.com
              </p> */}
              <p className="flex items-center gap-2">
                <Icon icon="mdi:map-marker" className="lg:w-7 w-5 h-6" />
                Adres: Oruç Reis Mahallesi Tekstilkent İş Merkezi A8 Blok No:42 istanbul
              </p>
            </div>
          </div>

          {/* Google Maps */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#2E3192]">Konumumuz</h3>
            <div className="rounded-lg overflow-hidden">
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d752.0298150164898!2d28.8650833!3d41.0663857!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x14cab00137bc7a7d%3A0x56ccbec3254dc381!2sOru%C3%A7reis%2C%20Tekstilkent%20A8%20Blok%2C%2034235%20Esenler%2F%C4%B0stanbul!5e0!3m2!1str!2str!4v1760215387196!5m2!1str!2str"
                width="100%" 
                height="200" 
                style={{border:0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Gainservo Konumu"
              ></iframe>
            </div>
          </div>
        </div>
        
        {/* Alt Çizgi */}
        <div className="border-t border-[#CCDC59]/20 mt-8 pt-4 text-center text-sm text-gray-400">
          <p>© 2025 Gainservo. Tüm hakları saklıdır.</p>
        </div>
      </div>
    </footer>
  )
}

export default Footer
